import vars from '../helpers';

const navInit = () => {
	if (vars.isDesktop()) {
		return;
	}

	const headerBurger = document.querySelector('.header__burger');
	const headerLink = document.querySelectorAll('.header__link, .header__sign');

	headerBurger.addEventListener('click', (e) => {
		const header = e.target.closest('.header');

		header.classList.toggle('is-active');

		if (header.classList.contains('is-active')) {
			scrollLock.disablePageScroll();
		} else {
			scrollLock.enablePageScroll();
		}
	});

	headerLink.forEach((link) => {
		link.addEventListener('click', (e) => {
			const header = e.target.closest('.header');

			header.classList.toggle('is-active');

			if (header.classList.contains('is-active')) {
				scrollLock.disablePageScroll();
			} else {
				scrollLock.enablePageScroll();
			}
		});
	});
};

export default navInit;
